import * as actions from './actions';

const initialState = {}; // new InitialState;

export default function mycasaFakenReducer(state = initialState, action) {
  switch (action.type) {

    case actions.INIT_MYCASA_FAKE_START: {
      return Object.assign({}, state, {
        isFetching: true,
        errorMessage: '',
      });
    }

    case actions.INIT_MYCASA_FAKE_SUCCESS: {
      return Object.assign({}, action.payload, state, {
        isFetching: false,
        errorMessage: '',
      });
    }

    case actions.INIT_MYCASA_FAKE_ERROR: {
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.payload.message,
      });
    }

    case actions.FETCH_DATA_MYCASA_FAKE_START: {
      return Object.assign({}, state, {
        isFetching: true,
        errorMessage: '',
      });
    }

    case actions.FETCH_DATA_MYCASA_FAKE_SUCCESS: {
      return Object.assign({}, action.payload, state, {
        isFetching: false,
        hasFetched: true,
        errorMessage: '',
      });
    }

    case actions.FETCH_DATA_MYCASA_FAKE_ERROR: {
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.payload.message,
      });
    }
    
    default: {
      return state;
    }
  }
}
